import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiService from "../../../services/service";
import API_ROUTES from "../../../api-routes";

const initialState = {
  registerAddress: null,
  status: "idle",
  error: null,
};

export const fetchCountries = createAsyncThunk(
  "address/fetchCountries",
  async () => {
    const response = await apiService("/entity/myentities/countries");
    if (!response.ok) {
      throw new Error("Response was not ok");
    }
    const data = await response.json();
    return data;
  },
);

export const fetchStates = createAsyncThunk(
  "address/fetchStates",
  async (country) => {
    const { data } = await apiService(API_ROUTES.FETCH_STATES, "GET", {
      replace: { country },
    });
    return data;
  },
);

export const fetchCities = createAsyncThunk(
  "address/fetchCities",
  async (codes) => {
    const { data } = await apiService(API_ROUTES.FETCH_CITIES, "GET", {
      replace: { country: codes[0], state: codes[1] },
    });
    return data;
  },
);

export const fetchAddress = createAsyncThunk(
  "address/fetchAddress",
  async (arg) => {
    // Support both old signature (id string) and new signature ({ id, skipCache })
    const id = typeof arg === "object" ? arg.id : arg;
    const skipCache = typeof arg === "object" ? arg.skipCache : false;
    const res = await apiService(API_ROUTES.FETCH_ADDRESSES, "GET", {
      replace: { id },
      skipCache,
    });
    return res;
  },
);

export const addAddress = createAsyncThunk(
  "/entity/addAddress",
  async ({ data, id }, thunkAPI) => {
    try {
      return await apiService(API_ROUTES.ADD_ADDRESS, "POST", {
        body: JSON.stringify(data),
        replace: { id },
      });
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const deleteAddress = createAsyncThunk(
  "/entity/addAddress",
  async (id, thunkAPI) => {
    try {
      return await apiService(API_ROUTES.DELETE_ADDRESS, "DELETE", {
        replace: { id },
      });
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
export const editAddress = createAsyncThunk(
  "/entity/editAddress",
  async (payload, thunkAPI) => {
    try {
      return await apiService(API_ROUTES.UPDATE_ADDRESS, "PUT", {
        body: JSON.stringify(payload),
        replace: { id: payload.id },
      });
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

const addressesSlice = createSlice({
  name: "addresses",
  initialState,
  reducers: {
    resetAddresses: (state) => {
      state.status = "idle";
      state.registerAddress = null;
      state.tradingAddress = null;
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchAddress.pending, (state) => {
        state.status = "loading";
        state.isloading = true;
      })
      .addCase(fetchAddress.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.currentAddress = action.payload;
        state.addressdata = action.payload.data;
        state.isloading = false;
      })
      .addCase(fetchAddress.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        state.isloading = false;
      })
      .addCase(fetchCities.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCities.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.cities = action.payload;
      })
      .addCase(fetchCities.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchStates.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchStates.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allstates = action.payload;
      })
      .addCase(fetchStates.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchCountries.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allcountries = action.payload;
      })
      .addCase(fetchCountries.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { resetAddresses } = addressesSlice.actions;
export default addressesSlice.reducer;
